import React from 'react'
import styles from './StrackInfo.module.scss'

export function StrackInfo({ children }) {
  return <div className={styles.infoOverlayContainer}>{children}</div>
}
